class mTextLoop extends HTMLDivElement {
    constructor() {
        super();
        this.marquee = this.querySelector('span');
    }

    connectedCallback() {
        this.widthSpan();
        this.onResize();
        this.productImagesCountPosition();
    }

    onResize() {
        window.addEventListener('resize', () => {
            this.widthSpan();
        });
    }

    widthSpan() {
        const sizeSpan = this.marquee.clientWidth;
        this.firstElementChild.style.setProperty('--tag-size-loop', sizeSpan);
    }

    productImagesCountPosition() {
        if (this.closest('[is="m-product-tile"]')) {
            this.closest('[is="m-product-tile"]').classList.add('count-position');
        }
    }
}

customElements.define('m-text-loop', mTextLoop, {
    extends: 'div'
});
